

import ClientHead from "@/components/main/core/ClientHead";
import RedSection from "@/components/main/core/RedSection";
import CheckBox from "@/components/main/core/CheckBox";
import FormButton from "@/components/main/buttons/FormButton";
import isMobile from "@/mixins/isMob";

export default {

  head() {
    const title = 'Terms & Conditions | iFindCheaters';
    const description = 'Review our Terms & Conditions at iFindCheaters to understand how we operate and ensure a safe and secure experience for all users.';

    return {
      title: title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Personal Data Security, Privacy Policy Compliance, GDPR Compliance, Terms and Condition, How to use iFindCheaters, Guidelines to use cheater lookup app'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/terms/",
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Terms and conditions",
            }],
          }
        }
      ]
    };
  },

  name: "terms",
  layout: 'clientLayout',
  mixins: [isMobile],
  components: { ClientHead, FormButton, RedSection, CheckBox,  },
  data() {
    return {
      terms: 'TERMS OF USE FOR SINGLE USE PURCHASE'
    }
  },
  computed: {},
  mounted() {
  },
  methods: {
    setTerms(text) {
      this.terms = text;
    }
  }
}
